export const GHOST_ICONS_RENDER_MODE = {
	HIDDEN: 'hidden',
	ANIMATED: 'animated',
	STATIC: 'static',
} as const;
